const graph = {
  "queryState": {
    "layerCatalogLoadFailed": "Failed to load the layer list",
    "savedSectionListLoadFailed": "Failed to load saved data",
    "exportListLoadFailed": "Failed to load the export file list",
    "shootingDateListLoadFailed": "Failed to load the shooting date list",
  },
  "checkCrossSection": "Check Cross Section",
  "checkLongitudeSection": "Check Elevation Profile",
  "height": "height",
  "distance": "distance",
  "line": "Linear",
  "alignment": "Alignment",
  "stratum": "stratum",
  "designHeight": "Drawing",
  "check": "Check",
  "longitudeSection": "Elevation profile",
  "specificSection": "Specific",
  "crossSection": "Cross Section",
  "crossSectionList": "Cross Section",
  "crossSectionGraph": "Cross Section Graph",
  "perpendicularInterval": "Cross Interval",
  "pointInterval": "Point Interval",
  "pointSetting": "Set up a point",
  "detailSetting": "Detailed settings",
  "startPoint": "Start Point",
  "endPoint": "End Point",
  "section": "Section",
  "sectionStartPoint": "Start Point",
  "sectionEndPoint": "End Point",
  "original": "original",
  "detail": "detailed",
  "startPointError": "The starting station cannot be smaller than the default value",
  "enterBranch": "Please enter a branch",
  "validate": {
    "dxfSaveFileDownloadError": "An error occurred while downloading the file. Please try again.",
    "dxfSaveFileGenerateNotice": "You have been requested to create an file. It's usually done within 10 minutes. Please check it out in a moment.",
    "dxfSaveFileGenerateError": "Failed to create file. Please try again in a moment.",
    "noSavedData": "No data has been saved.",
    "failDeleteData": "Failed to delete data. Please try again.",
    "savePerpendicular": "The cross-section has been saved.",
    "deletePerpendicular": "The cross-section has been deleted.",
    "existingCrossSection": "A cross-section has already been saved. Please delete it and try again.",
    "leftRightSpacing": "The left and right spacing must be greater than the point spacing.",
    "pointIntervalMin": "The point spacing must be at least {{min}} m.",
    "endPointInfo": "If the end point is not specified or if it is longer than the linear length, the entire cross-section will be displayed.",
    "lngStartPoint": "The start point of the cross-section is only reflected in the TEXT file.",
    "startStepError": "The starting station cannot be smaller than the default value",
    "endStepError": "The end point cannot be smaller than the start point.",
    "sameStepError": "The start and end points cannot be the same.",
    "maxStratumFilesSelected": "You can select up to three files only.",
    "maxStep": "The value must be less than or equal to 100.",
    "increment": "The value must be a multiple of 5",
    "equal": "The point interval must be equal to or less than the cross interval.",
    "setPoint": "Please set the starting point and the endpoint.",
    "pointAdditionError": "The additional point cannot be smaller than the starting point.",
    "pointAdded": "A specific cross-section has been added.",
    "pointAdditionFailed": "Failed to add a specific cross-section. Please try again later.",
    "pointAdditionTargetFailed": "The cross section already exists on this street. Please check the specific street.",
    "distanceExceedsSegmentLength": "The entered distance exceeds the length of the segment.",
    "crossSectionDeletionFailed": "Failed to delete the cross-section. Please try again later."
  },
  "perpendicularList": "Saved Cross Sections",
  "selectPerpendicular": "Please select a cross section",
  "perpendicularDeleted": "Cross section has been deleted.",
  "deleteSavedTitle": "Delete Saved Cross Section",
  "deleteSavedSectionMessage": "Delete section {{name}}?",
  "deleteSavedStationMessage": "Delete station {{name}}?",
  "exportSection": "Export",
  "enterDistance": "Please enter a distance.",
  "enterDistanceInRange": "Please enter within the range.",
  "perpendicularDataNotFound": "Cross section data not found at specified distance.",
  "specialPerpendicularAdded": "Special cross section has been added.",
  "perpendicularAlreadyExists": "A cross section already exists at this location.",
  "specialPerpendicularAddFailed": "Failed to add special cross section.",
  "perpendicularGraph": "Cross Section Graph",
  "addSpecialPerpendicular": "Add Special Cross Section",
  "noSavedData": "No saved data.",
  "loading": "Loading",
  "delete": "Delete",
  "cancel": "Cancel",
  "edit": "Edit",
  "confirm": "Confirm",
  "perpendicularSelectionTree": "Cross Section Selection Tree",
  "loadingInProgress": "Loading...",
  "createFile": "Please create a file.",
  "exportPerpendicularData": "Export Cross Section Data",
  "invalidFileFormat": "Invalid file format.",
  "fileReadFailed": "Failed to read file.",
  "noSectionSelected": "No section selected.",
  "selectFileToExport": "Please select a file to export.",
  "noExportableFiles": "No files available to export.",
  "csvDownloaded": "CSV file has been downloaded.",
  "csvDownloadFailed": "Failed to download CSV.",
  "dxfDownloaded": "DXF file has been downloaded.",
  "dxfDownloadFailed": "Failed to download DXF.",
  "earthworkTableFeatureComingSoon": "Earthwork summary table download feature is coming soon.",
  "selectFileToDelete": "Please select a file to delete.",
  "fileDeleted": "File has been deleted.",
  "fileNotFound": "File not found.",
  "fileDeletionFailed": "Failed to delete file.",
  "selectFileToRename": "Please select a file to rename.",
  "noFileNameChanged": "No file name has been changed.",
  "fileRenamed": "File has been renamed.",
  "duplicateFileName": "A file with the same name already exists.",
  "fileRenameFailed": "Failed to rename file.",
  "fileNameSlashNotAllowed": "The character / is not allowed in file names.",
  "fileInfoNotFound": "File information not found.",
  "fileUpdateStarted": "File update has been started.",
  "perpendicularDataNotFoundForUpdate": "Cross section data not found.",
  "fileUpdateFailed": "Failed to update file.",
  "fileName": "File Name",
  "includedFiles": "Included Files",
  "updateDate": "Update Date",
  "update": "Update",
  "done": "Done",
  "creating": "Creating",
  "rename": "Rename",
  "download": "Download",
  "txtDownloadHelp": "You can draw cross-sections in RP and BIMNODE programs.",
  "earthworkTable": "Earthwork Table",
  "earthworkTableRequirement": "Earthwork table requires both ground level and plan level",
  "earthworkTableNoData": "No summary table data available.",
  "earthworkTableDownloaded": "Earthwork summary table has been downloaded.",
  "earthworkTableDownloadFailed": "Failed to download earthwork summary table.",
  "earthworkStationQuantity": "Earthwork Station Quantity",
  "earthworkStationQuantityRequirement": "Earthwork station quantity requires both ground level and plan level",
  "earthworkStationQuantityNoData": "No station fill/cut data available.",
  "earthworkStationQuantityDownloaded": "Earthwork station quantity has been downloaded.",
  "earthworkStationQuantityDownloadFailed": "Failed to download earthwork station quantity.",
  "select": "Select",
  "itemsSelected": "items selected",
  "multipleSelectable": "Multiple selectable",
  "singleSelectable": "Single selectable",
  "selectStandardTimeSeries": "Select Standard Time Series",
  "standard": "Base",
  "elevationProfile": "Elevation Profile",
  "partialMode": "Partial Mode",
  "resetView": "Reset View",
  "crossSectionElevationProfile": "Cross Section Elevation Profile",
  "crossSectionNumber": "th Cross Section",
  "station": "Station",
  "quantityTable": "Quantity Table",
  "quantityTableTooltip": "You can view the quantity table if the drawing\nhas both design height and ground height.",
  "crossSectionQuantityTable": "Cross Section Quantity Table",
  "baseDate": "Base",
  "excelDownload": "Excel Download",
  "noQuantityData": "Cannot calculate the quantity table because there is no design height or ground height at this location.",
  "planned": "Planned",
  "progressed": "Progressed",
  "currentHeight": "Current Height",
  "fill": "Fill",
  "cut": "Cut",
  "fillSubgrade": "Subgrade",
  "fillRoadbed": "Roadbed",
  "fillUncompacted": "Uncompacted",
  "fillRockFill": "Rock Fill",
  "cutSoilCut": "Soil Cut",
  "cutRipping": "Ripping",
  "cutBlasting": "Blasting",
  "earthworkSection": "Section",
  "earthworkFillGroup": "Fill",
  "earthworkCutGroup": "Cut",
  "earthworkSubtotal": "Subtotal",
  "earthworkColType": "Type",
  "earthworkColMaterial": "Material",
  "earthworkColPlannedQty": "Planned Quantity",
  "earthworkColRemainingQty": "Remaining Quantity",
  "earthworkColDailyTotal": "Daily Total",
  "earthworkKeyDesignHeight": "Design Height",
  "earthworkKeyGroundHeight": "Ground Level",
  "timeSeries": "Status",
  "maxFourSelectable": "*Max 4 selectable",
  "complete": "Done",
  "layer": "Layer",
  "planDropdown": "Plan",
  "stratumDropdown": "Stratum",
  "legendGround": "Ground Level",
  "legendDesign": "Design Height",
  "stratumMaxThree": "Stratum (Max 3 selectable)",
  "groundMaxOne": "Ground Height (1 selectable)",
  "designMaxOne": "Design Height (1 selectable)",
  "noAvailableLayers": "No available layers",
  "earthworkSummaryTable": "Overall Earthwork Summary Table",
  "downloadOverallSummaryTable": "Download Overall Summary Table",
  "summaryTableTooltip": "You can view the overall summary table after creating a cross-section file."
} as const;

export default graph;
